import { Link, Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-museum-paper border-b border-museum-line">
        <div className="max-w-6xl mx-auto px-5 py-4 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 min-w-0">
            <img
              src="/ibew-logo.png"
              alt="IBEW seal"
              width={44}
              height={44}
              className="w-11 h-11 rounded-full shrink-0"
            />
            <div className="leading-tight min-w-0">
              <div className="text-[10px] uppercase tracking-eyebrow text-museum-muted truncate">
                Electrical Workers Historical Society
              </div>
              <div className="font-serif text-lg text-museum-ink truncate">
                Henry Miller Museum
              </div>
            </div>
          </Link>
          <nav className="text-sm flex items-center gap-5 shrink-0">
            <Link
              to="/events"
              className="text-museum-ink hover:text-museum-accent"
            >
              Events
            </Link>
            <Link
              to="/donate"
              className="text-museum-ink hover:text-museum-accent"
            >
              Donate
            </Link>
            <a
              href="https://ibew.org/our-history-museum/henry-miller-museum/"
              target="_blank"
              rel="noopener noreferrer"
              title="Opens on ibew.org in a new tab"
              aria-label="About IBEW International (opens in a new tab)"
              className="text-museum-ink hover:text-museum-accent inline-flex items-center gap-1"
            >
              About
              <svg
                aria-hidden="true"
                viewBox="0 0 16 16"
                width="11"
                height="11"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                className="opacity-70"
              >
                <path d="M6 3h7v7" />
                <path d="M13 3 6.5 9.5" />
                <path d="M11 9v4H3V5h4" />
              </svg>
            </a>
            <Link
              to="/"
              className="hidden sm:inline text-museum-accent border-b border-museum-rule pb-0.5"
            >
              Plan a visit
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-museum-line bg-museum-paperDeep/60">
        <div className="max-w-6xl mx-auto px-5 py-9 grid sm:grid-cols-3 gap-6 text-sm">
          <div>
            <div className="text-[10px] uppercase tracking-eyebrow text-museum-muted mb-2">
              Visit
            </div>
            <div className="text-museum-ink font-medium">Henry Miller Museum</div>
            <div className="text-museum-muted">2728 Martin Luther King Dr.</div>
            <div className="text-museum-muted">St. Louis, Missouri</div>
            <div className="text-museum-muted mt-1">By appointment</div>
            <a
              href="tel:+13146475900"
              className="text-museum-accent block mt-1"
            >
              (314) 647-5900
            </a>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-eyebrow text-museum-muted mb-2">
              Connect
            </div>
            <a
              href="https://ibew.org/our-history-museum/henry-miller-museum/"
              target="_blank"
              rel="noopener noreferrer"
              title="Opens on ibew.org in a new tab"
              className="inline-flex items-center gap-1 text-museum-ink hover:text-museum-accent"
            >
              IBEW · About the museum
              <svg aria-hidden="true" viewBox="0 0 16 16" width="11" height="11"
                   fill="none" stroke="currentColor" strokeWidth="1.5"
                   className="opacity-70">
                <path d="M6 3h7v7" />
                <path d="M13 3 6.5 9.5" />
                <path d="M11 9v4H3V5h4" />
              </svg>
            </a>
            <a
              href="mailto:members@ibewlocal1.org"
              className="block text-museum-muted hover:text-museum-accent mt-1"
            >
              members@ibewlocal1.org
            </a>
          </div>
          <div className="sm:text-right">
            <div className="text-[10px] uppercase tracking-eyebrow text-museum-muted mb-2">
              Staff
            </div>
            <Link
              to="/admin/login"
              className="text-museum-muted hover:text-museum-accent"
            >
              Sign in →
            </Link>
            <div className="text-xs text-museum-muted mt-3">
              © Henry Miller Museum
            </div>
            <div className="text-xs text-museum-muted">
              Operated by the Electrical Workers Historical Society
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
